import WebComponent from '../base/WebComponent';
import MediaService from '../../services-js/media.service';
import ProductService from "../../services/api/product";

class WProductCarousel extends WebComponent {
    observedAttrs = ["productList", "currentProgramUrl", "productIds", "siteId"];
    static settings = {
        sizesAtBp: {
            desktop: 2,
            mobile: 1
        }
    };

    sizes = window.matchMedia("(max-width: 768px)").matches
        ? WProductCarousel.settings.sizesAtBp.mobile
        : WProductCarousel.settings.sizesAtBp.desktop;

    currentIndex = 0;
    productGroups = [];
    offsetWidth = 0;
    currentIndex = 0;
    hideNav = true;
    container = null;
    props = {
        productList: []
    };
    currentProgramUrl = null;
    siteId = this.getAttribute("site-id") ? this.getAttribute("site-id") : null;
    productIds = this.getAttribute("product-ids") ? this.getAttribute("product-ids").split(",") : null;
    touchCoords = {
        touchstartX: 0,
        touchendX: 0
    };

    constructor() {
        super();
    }

    beforeMount() {
        return new Promise(async (resolve, reject) => {
            if (this.props.productList.length > 0) {
                await this.setup();
            } else if (this.productIds != null && this.siteId != null) {
                await this.setupByIds();
            }

            resolve(true);
        });
    }

    setupByIds() {
        var currentProductIds = this.productIds;
        var validatedProductIds = [];

        for (var i = 0; i < currentProductIds.length; i++) {
            var currentProductId = currentProductIds[i];
            if (!isNaN(parseInt(currentProductId))) {
                validatedProductIds.push(currentProductId);
            }
        }
        return new Promise(async (resolve, reject) => {
            ProductService
            .getProductsById({ data: { siteId: this.siteId, products: validatedProductIds }, urlExt: "" })
            .then((productArray) => {
                this.props.productList = productArray;
                resolve(this.setup());
            });
        });
    }

    setup() {
        return new Promise(async (resolve, reject) => {
            await this.fetchProductImageUrl();
            await this.buildGroups();
            this.offsetWidth = this.container?.offsetWidth;
            resolve(true);
        });
    }

    mounted() {
        const navArrow = this.querySelectorAll(".product-carousel__navigation__item");
        this.container = this.querySelector(".product-carousel__slides");

        for (let index = 0; index < navArrow.length; index++) {
            navArrow[index].addEventListener("click", () => {
                this.navigateSlideIndex(navArrow[index].getAttribute("ref") === "arrow-forward");
            });
        }

        this.resizeHandler();
        window.addEventListener("resize", (e) => {
            this.resizeHandler();
        });
    }

    resizeHandler() {
        this.container?.addEventListener(
            "touchstart",
            function (event) {
                this.touchCoords.touchstartX = event.changedTouches[0].screenX;
            },
            false
        );

        this.container?.addEventListener(
            "touchend",
            function (event) {
                this.touchCoords.touchendX = event.changedTouches[0].screenX;
                this.navigateSlideIndex(this.touchCoords.touchendX < this.touchCoords.touchstartX);
            },
            false
        );

        clearTimeout(window.resizeTimer);
        window.resizeTimer = setTimeout(async () => {
            this.offsetWidth = this.container?.offsetWidth;
            this.sizes = window.matchMedia("(max-width: 768px)").matches
                ? WProductCarousel.settings.sizesAtBp.mobile
                : WProductCarousel.settings.sizesAtBp.desktop;
            await this.buildGroups();

            this.querySelectorAll(".product-carousel__slide").forEach((elm) => {
                elm.style.minWidth = this.offsetWidth + "px";
            });
            this.updateSlidesOffset();
        }, 250);
    }

    fetchProductImageUrl() {
        return new Promise(async (resolve, reject) => {
            this.props.productList = await Promise.all(
                this.props.productList.map((item) => {
                    return new Promise(async (resolve, reject) => {
                        item.productImageUrl = item.imageCropUrl ? item.imageCropUrl : null;
                        resolve(item);
                    });
                })
            );
            resolve(true);
        });
    }

    buildGroups() {
        return new Promise((resolve, reject) => {
            this.productGroups = [];
            if (this.props.productList && this.props.productList.length > 0) {
                let group = [];
                this.hideNav = this.props.productList.length <= this.sizes;
                for (let key = 0; key < this.props.productList.length; key++) {
                    const product = this.props.productList[key];
                    group.push(product);
                    while (key == this.props.productList.length - 1 && group.length < this.sizes) {
                        group.push({});
                    }
                    if (group.length >= this.sizes) {
                        this.productGroups.push(group);
                        group = [];
                    }
                }
            }

            resolve(true);
        });
    }

    navigateSlideIndex(navigateForward) {
        if (navigateForward) {
            this.currentIndex = this.currentIndex + 1 > this.productGroups.length - 1 ? 0 : this.currentIndex + 1;
        } else {
            this.currentIndex = this.currentIndex - 1 < 0 ? this.productGroups.length - 1 : this.currentIndex - 1;
        }
        this.updateSlidesOffset();
    }

    updateSlidesOffset() {
        if (this.querySelector(".product-carousel__slides-rail")) {
            this.querySelector(".product-carousel__slides-rail").style.transform =
                "translateX(-" + this.offsetWidth * this.currentIndex + "px)";
        }
    }

    template() {
        return `
            <section class="product-carousel" ref="carouselMain">
                <div class="product-carousel__slides">
                    <div class="product-carousel__slides-rail">
                        ${this.wFor(this.productGroups, (productGroup) => {
                            return `
                            <div 
                                class="product-carousel__slide"
                                style="min-width: ${this.offsetWidth + "px"}"
                            >
                                ${this.wFor(productGroup, (item) => {
                                    return `
                                        <article 
                                            class="product-carousel__slide-item" 
                                            style="width: ${100 / productGroup.length + "%"}"
                                        >
                                            <a 
                                                class="product-carousel__link"
                                                href="${
                                                    item.primaryUrl
                                                        ? item.primaryUrl
                                                        : this.currentProgramUrl
                                                        ? this.currentProgramUrl + item.urlName
                                                        : "/" + item.areaUrlName + "/program/" + item.urlName
                                                }"
                                            >
                                                ${
                                                    item.imageId
                                                        ? `
                                                    <div 
                                                        class="product-carousel__slide-item__image"
                                                        style="background: url('${
                                                            item.product && item.product.productImageUrl
                                                                ? item.product.productImageUrl
                                                                : item.productImageUrl
                                                        }')"
                                                    ></div>
                                                `
                                                        : ""
                                                }
                                                ${
                                                    item.name && !item.imageId
                                                        ? `
                                                    <h1 class="product-carousel__slide-item__title text-graphic">
                                                        ${item.name}
                                                    </h1>
                                                `
                                                        : ""
                                                }
                                                ${
                                                    item.categoryName
                                                        ? `
                                                    <div class="product-carousel__slide-item__categoryName">
                                                        ${item.categoryName}
                                                    </div>
                                                `
                                                        : ""
                                                }
                                                ${
                                                    item.name && item.imageId
                                                        ? `
                                                    <h1 class="product-carousel__slide-item__title">
                                                        ${item.name}
                                                    </h1>
                                                `
                                                        : ""
                                                }
                                            </a>
                                        </article>
                                    `;
                                })}
                            </div>
                            `;
                        })}
                        
                    </div>
                </div>
                ${this.wFor(["back", "forward"], (direction) => {
                    return `
                    <div 
                        class="product-carousel__navigation__item product-carousel__navigation__${direction} ${
                        this.hideNav ? "hidden" : ""
                    }"
                        ref="arrow-${direction}"
                    >
                        <div class="product-carousel__navigation__aligner">
                            <div class="product-carousel__navigation__item-wrapper">
                                ${
                                    direction == "back"
                                        ? `
                                    <svg width="1em" height="1em" viewBox="0 0 26.757 21.317" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="translate(1686.1 1003.7) rotate(180)" data-name="Group 202">
                                            <g transform="translate(791.83 -299.44)" fill="none" stroke="currentColor" stroke-width="2" data-name="Group 199">
                                                <path transform="translate(882.89 1302.4) rotate(-90)" d="M0,0,9.951,9.952,19.9,0" data-name="Path 20"/>
                                                <line transform="translate(867.5 1292.5)" x1="25" data-name="Line 1"/>
                                            </g>
                                        </g>
                                    </svg>
                                `
                                        : `
                                    <svg width="1em" height="1em" viewBox="0 0 26.757 21.317" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="translate(-867.5 -1281.8)" fill="none" stroke="currentColor" stroke-width="2" data-name="Group 199">
                                            <path transform="translate(882.89 1302.4) rotate(-90)" d="M0,0,9.951,9.952,19.9,0" data-name="Path 20"/>
                                            <line transform="translate(867.5 1292.5)" x1="25" data-name="Line 1"/>
                                        </g>
                                    </svg>
                                `
                                }
                            </div>
                        </div>
                    </div>
                    `;
                })}
            </section>
        `;
    }
}

customElements.define( 'w-product-carousel', WProductCarousel );
